import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { AppFeaturesState } from './app-feature.state';
import { AuthState } from './auth.state';
import { RoutingState } from './routing.state';
import { GuardianState } from './guardian.state';

@NgModule({
  declarations: [],
  imports: [CommonModule, NgxsModule.forFeature([AppFeaturesState, AuthState, RoutingState, GuardianState])],
})
export class PortalModule {}
